
import React, { useState, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import Spinner from '../components/common/Spinner';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const authContext = useContext(AuthContext);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!authContext) return;
    
    setLoading(true);
    setError('');
    
    try {
      await authContext.login(email, password);
    } catch (err) {
      console.error("Login failed:", err);
      const errorCode = (err as { code?: string })?.code;
      if (errorCode === 'auth/user-not-found' || errorCode === 'auth/wrong-password' || errorCode === 'auth/invalid-credential') {
        setError('Invalid email or password.');
      } else {
        setError('An unexpected error occurred. Please try again.');
      }
      setLoading(false);
    }
  };

  const displayError = authContext?.authError || error;

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-gray-900 border border-gray-800 rounded-2xl shadow-2xl p-8 space-y-6">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-white">
              <span className="text-blue-400">MysteryShopper</span>IA
            </h1>
            <p className="text-gray-400 mt-2">AI Mystery Shopper Analysis</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="text-sm font-medium text-gray-300 block mb-2">Email Address</label>
              <input 
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                placeholder="you@example.com"
                autoComplete="email"
              />
            </div>
            <div>
              <label htmlFor="password" className="text-sm font-medium text-gray-300 block mb-2">Password</label>
              <input 
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>

            {displayError && <p className="text-sm text-red-400 text-center">{displayError}</p>}
            
            <button type="submit" disabled={loading} className="w-full bg-blue-600 text-white font-bold py-2.5 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-blue-500 transition-colors duration-300 disabled:bg-gray-600 disabled:cursor-not-allowed">
              {loading ? <Spinner size="sm" /> : 'Sign In'}
            </button>
          </form>
          <p className="text-xs text-gray-600 text-center">
            This is a private platform. Only authorized users can sign in.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;